import { Injectable }          from '@angular/core';
import {
	Event,
	NavigationEnd,
	Router
}                              from '@angular/router';
import { LoggerService }       from '@app/shared/services/logger.service';
import { LogAnalyticsService } from '@core/analytics/log-analytics.service';
import {
	IModalOptions,
	ModalBaseEventTypeEnum,
	ModalSizeEnum
}                              from '@core/modals/modal.model';
import {
	NgbModal,
	NgbModalOptions
}                              from '@ng-bootstrap/ng-bootstrap';
import {
	from,
	of
}                              from 'rxjs';
import {
	catchError,
	filter,
	take
}                              from 'rxjs/operators';


@Injectable()
export class ModalService {

	constructor(
		private readonly modal: NgbModal,
		private readonly _logAnalyticsService: LogAnalyticsService,
		private readonly logger: LoggerService,
		private readonly router: Router
	) {}


	public createModal(
		modalComponent,
		dataList?: { key: string, value: any }[],
		size?: 'sm' | 'lg' | 'xl',
		centered?: boolean,
		windowClass?: string,
		modalOption?: IModalOptions
	) {

		let ngbModalOption: NgbModalOptions;
		if ( modalOption?.asFullpage ) {
			ngbModalOption = { ...modalOption.asFullpage };

			ngbModalOption = {
				...ngbModalOption,
				backdrop: false,
				keyboard: false,
				windowClass: ngbModalOption?.windowClass ? ngbModalOption.windowClass + ' fullPage' : 'fullPage'
			};
		}

		// kept for backward compatibility, remove fullpage condition after old modals are refactored to either fullpage or overlay configs
		if ( (
					 !modalOption?.asFullpage
				 ) || modalOption?.asOverlay ) {
			ngbModalOption = modalOption?.asOverlay ? { ...modalOption.asOverlay } : {};

			ngbModalOption = {
				...ngbModalOption,
				animation: ngbModalOption?.animation ?? true,
				centered: ngbModalOption?.centered ?? true,
				size: ngbModalOption?.size ?? ModalSizeEnum.LG,
				windowClass: ngbModalOption?.windowClass ? ngbModalOption.windowClass + ' overlay' : 'overlay',
				backdrop: ngbModalOption?.backdrop ?? true,
				keyboard: ngbModalOption?.keyboard ?? false,
				backdropClass: ngbModalOption?.backdropClass ? ngbModalOption.backdropClass + ' overlay' : 'overlay'
			};

			// kept for backward compatibility, remove after old modals are refactored to either fullpage or overlay configs
			if ( centered ) { ngbModalOption.centered = centered; }
			if ( size ) { ngbModalOption.size = size; }
			if ( windowClass ) { ngbModalOption.windowClass = windowClass; }
		}

		// create modal instance
		const modalRef = this.modal.open( modalComponent, ngbModalOption );

		// log to analytics
		this._logAnalyticsService.logModalView( dataList, modalComponent.name );

		this.router.events
		.pipe(
			filter( ( routerEvent: Event ) => routerEvent instanceof NavigationEnd ),
			take( 1 )
		)
		.subscribe( () => {
			modalRef?.close( { action: ModalBaseEventTypeEnum.CLOSE } );
		} );

		// pass properties to modal component
		if ( Array.isArray( dataList ) ) {
			dataList.forEach( dataItem => {
				return modalRef.componentInstance[ dataItem.key ] = dataItem.value;
			} );
		}

		// return modal result
		return from( modalRef.result )
		.pipe(
			catchError( error => {
				this.logger.log( error );
				return of( { action: 'error', data: error } );
			} )
		);
	}

}
